export default function mapPropsToValues() {
  return {
    email: "",
    password: "",
  };
}
